export default __webpack_public_path__ + "static/media/28_E.4f47d4f1.svg";